import React from "react";
import CommonLoanDetail from "../ongoincasetabs2/common-loan-detail";

export default function VolvoCaseDetail(props) {
  const { caseDetail } = props;
  return <CommonLoanDetail caseDetail={caseDetail} />;
}
